<template>
    <div>
        <rkm-table
            :items="model.items"
            :fields="fields"
            hide-filters
            hide-pagination
        >
            <template v-slot:cell(prescrito)="{ item }">
                <template v-if="item.continuo">
                    Continuo
                </template>
                <template v-else>
                    {{ item.prescrito }}
                </template>
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    :color="item.observacao ? 'info' : 'secondary'"
                    small
                    v-rkm-popover.hover.left="{
                        title:'Observação',
                        html:true,
                        content: item.observacao
                            ? item.observacao
                            : 'Nenhuma observação informada.',
                    }"
                >
                    <i class="fas fa-comment-alt"></i>
                </rkm-button>

                <rkm-button
                    @click.stop="edit(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click.stop="remove(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
import { object, data } from '@/mixins'
import moment from 'moment'

export default {
    computed: {
        fields() {
            return [
                { label: "Item", key: "material.descricaoCompleta", searchable: true },
                { label: "Ações", key: "actions", searchable: true, class: "col-min" },
            ]
        }
    },
    methods: {
        edit(item) {
            const itemClone = this.clone(item)
            itemClone.dispensadoEm = moment(this.form.dataAtual, 'DD/MM/YYYY').format('YYYY-MM-DD')
            this.model.item = itemClone
        },
        remove(item) {
            this.showDeleteConfirmation(
                "Deseja realmente excluir o item?",
                async () => {
                    const idx = this.model.items.findIndex(i => i.id === item.id)
                    this.model.items.splice(idx, 1)
                }
            )
        }
    },
    mixins: [ object, data ],
    props: {
        form: { type: Object, default: null },
        model: { type: Object, default: null },
    }
}
</script>